import logo from './logo.svg';
import './App.css';
import UpMark from './component/UpMark.jsx';

function App() {
  return (
    <div>
      <UpMark/>
    </div>
  );
}

export default App;
